import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import CheckBox from './../../../components/PageLayout/CheckBox';
import Pager2 from './../../../components/PageLayout/Pager2';
export default function () {
    function onChecked1() {
        this.toggleSetAsMaster();
    }
    function onChange2(e) {
        this.handleSearchTextChanged(e);
    }
    function onClick3(s, sIndex) {
        this.selectRow(s);
    }
    function repeatS4(s, sIndex) {
        return React.createElement('li', {
            'className': classNames('sales-person-list__item', { 'sales-person-list__item--active': this.isRowSelected(s) }),
            'key': this.getRowText(s, -1),
            'onClick': onClick3.bind(this, s, sIndex)
        }, React.createElement('div', { 'className': 'sales-person-list__item-name' }, this.getRowText(s, 0)), React.createElement('div', { 'className': 'sales-person-list__item-store' }, this.getRowText(s, 1)));
    }
    function onClick5() {
        this.handleCancel();
    }
    function onClick6(e) {
        this.handleAssign(e);
    }
    return React.createElement('div', { 'className': 'ui-popup' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.state.title)), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, this.state.showSetMasterProfile ? React.createElement(CheckBox, {
        'checked': this.state.isMaster,
        'text': 'Master Profile',
        '}': true,
        'onChecked': onChecked1.bind(this),
        'key': '435'
    }) : null, React.createElement('div', { 'className': 'fabricators-popup-search' }, React.createElement('input', {
        'className': 'fabricators-popup-search__input',
        'placeholder': 'Search',
        'value': this.state.searchText,
        'onChange': onChange2.bind(this)
    })), React.createElement('div', { 'className': 'fabricators-popup-content' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'ui-list sales-person-list' },
        _.map(this.state.rows, repeatS4.bind(this))
    ])), Number.isInteger(this.props.totalPages) ? React.createElement(Pager2, {
        'page': this.props.page,
        'totalPages': this.props.totalPages,
        'pageClick': page => this.handlePageClick(page),
        'key': '1358'
    }) : null), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': onClick5.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': onClick6.bind(this)
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, '\r\n        ', this.state.buttonAssign, '\r\n      '))));
}